
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetUserGroupsConfig, GetUserGroupsConfigResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetUserGroupsConfigResponse, GetUserGroupsConfigResponse>) => response?.data;
const getError = (response?: SWRResponse<GetUserGroupsConfigResponse, GetUserGroupsConfigResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetUserGroupsConfigResponse, GetUserGroupsConfigResponse>) => ({});

const useGetUserGroupsConfig = (query?: Partial<GetUserGroupsConfig>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetUserGroupsConfig(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetUserGroupsConfig;